'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PublicationDate = function PublicationDate(_ref) {
  var publicationDate = _ref.publicationDate,
      _ref$separator = _ref.separator,
      separator = _ref$separator === undefined ? ' - ' : _ref$separator;
  return publicationDate ? _react2.default.createElement(
    'span',
    { className: 'cp-publication-date' },
    separator,
    publicationDate
  ) : null;
};

PublicationDate.propTypes = {
  publicationDate: _react.PropTypes.string.isRequired,
  separator: _react.PropTypes.string
};

exports.default = PublicationDate;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-publication-date/lib/components/PublicationDate.component.js
// module id = 1505
// module chunks = 1